import { useEffect, useRef } from "react"
import { ERouteStopType } from "../../../Enum/ERouteStopType"

interface Props {
  latitude: number
  longitude: number
  stopType: ERouteStopType
  label: string
}

export function CourierRouteStopMap({ latitude, longitude, stopType, label }: Props) {
  const mapContainerRef = useRef<HTMLDivElement | null>(null)
  
  const mapRef = useRef<google.maps.Map | null>(null)

  const markerRef = useRef<google.maps.Marker | null>(null)

  useEffect(() => {
    let isCancelled = false

    const renderMap = async () => {
      if (!mapContainerRef.current || !window.google?.maps?.importLibrary) {
        return
      }

      const { Map } = (await google.maps.importLibrary("maps")) as google.maps.MapsLibrary

      if (isCancelled || !mapContainerRef.current) {
        return
      }

      const position = { lat: latitude, lng: longitude }

      if (!mapRef.current) {
        mapRef.current = new Map(mapContainerRef.current, {
          center: position,
          zoom: 16,
          streetViewControl: false,
          mapTypeControl: false,
          fullscreenControl: false,
          gestureHandling: "greedy",
          clickableIcons: false,
        })
      } else {
        mapRef.current.setCenter(position)
      }

      const fillColor = stopType === ERouteStopType.Pickup ? "#2563eb" : "#059669"

      const icon: google.maps.Symbol = {
        path: google.maps.SymbolPath.CIRCLE,
        scale: 9,
        fillColor,
        fillOpacity: 1,
        strokeWeight: 2,
        strokeColor: "#ffffff",
      }

      if (!markerRef.current) {
        markerRef.current = new google.maps.Marker({
          map: mapRef.current,
          position,
          title: label,
          icon,
        })
      } else {
        markerRef.current.setPosition(position)
        markerRef.current.setIcon(icon)
        markerRef.current.setTitle(label)
      }
    }

    renderMap()

    return () => {
      isCancelled = true
    }
  }, [latitude, longitude, stopType, label])

  return <div ref={mapContainerRef} className="h-48 w-full rounded-md border border-slate-300" />
}
